console.time('wind profile template')

export const WIND_SPEED_SIZE = [26, 26]
export const WIND_SPEED_CENTER = [Math.round(WIND_SPEED_SIZE[0] / 2), Math.round(WIND_SPEED_SIZE[1] / 2)]

const Y_DIFF = (WIND_SPEED_SIZE[1] - 24) / 2

const createWindSpeedCanvas = (speed, rgb) => {
  let canvas = document.createElement('canvas')
  let [width, height] = WIND_SPEED_SIZE
  canvas.width = width
  canvas.height = height

  let ctx = canvas.getContext('2d')

  ctx.beginPath()
  ctx.strokeStyle = `RGB(${rgb.join(',')})`

  if (speed === 0) {
    ctx.arc(WIND_SPEED_CENTER[0], WIND_SPEED_CENTER[1], 2, 0, 2 * Math.PI)
  } else {
    if (speed === 36) {
      speed -= 2
    }

    let left = WIND_SPEED_CENTER[0] - (4 >> (((speed >> 2) - 1) >>> -1))
    let lastY = Y_DIFF
    ctx.moveTo(left, height - Y_DIFF)
    ctx.lineTo(left, lastY)

    let quotient = Math.floor(speed / 20)

    for (let i = 0; i < quotient; i++) {
      ctx.moveTo(left, lastY)
      ctx.lineTo(left + 8, lastY)
      lastY += 4
      ctx.lineTo(left, lastY)
    }

    let mod = speed % 20

    if (mod > 0) {
      quotient = Math.floor(mod / 4)

      for (let i = 0; i < quotient; i++) {
        ctx.moveTo(left, lastY)
        ctx.lineTo(left + 8, lastY)
        lastY += 4
      }

      mod = mod % 4

      if (mod > 0) {
        ctx.moveTo(left, lastY)
        ctx.lineTo(left + 4, lastY)
      }
    }
  }

  ctx.stroke()

  return canvas
}

export const windProfileConfigs = [{
  speed: 0,
  rgb: [0, 0, 255]
}, {
  speed: 2,
  rgb: [0, 51, 255]
}, {
  speed: 4,
  rgb: [0, 102, 255]
}, {
  speed: 6,
  rgb: [0, 153, 255]
}, {
  speed: 8,
  rgb: [0, 204, 255]
}, {
  speed: 10,
  rgb: [0, 255, 255]
}, {
  speed: 12,
  rgb: [0, 255, 204]
}, {
  speed: 14,
  rgb: [0, 255, 153]
}, {
  speed: 16,
  rgb: [0, 255, 102]
}, {
  speed: 18,
  rgb: [0, 255, 51],
  isLegend: false
}, {
  speed: 20,
  rgb: [0, 255, 0]
}, {
  speed: 22,
  rgb: [51, 255, 0],
  isLegend: false
}, {
  speed: 24,
  rgb: [102, 255, 0]
}, {
  speed: 26,
  rgb: [153, 255, 0],
  isLegend: false
}, {
  speed: 28,
  rgb: [204, 255, 0]
}, {
  speed: 30,
  rgb: [255, 255, 0],
  isLegend: false
}, {
  speed: 32,
  rgb: [255, 204, 0]
}, {
  speed: 36,
  rgb: [255, 102, 0]
}, {
  speed: 40,
  rgb: [255, 0, 0],
  isMaxVal: true
}, {
  speed: 60,
  rgb: [255, 0, 0]
}].map(({speed, rgb, isLegend = true, isMaxVal = false}) => ({
  speed,
  rgb,
  isLegend,
  isMaxVal,
  canvas: createWindSpeedCanvas(speed, rgb)
}))

export const windProfileTemplate = document.createElement('canvas')

const WIND_PROFILE_CONFIG_LENGTH = windProfileConfigs.length

windProfileTemplate.width = 361 * WIND_SPEED_SIZE[0]
windProfileTemplate.height = WIND_PROFILE_CONFIG_LENGTH * WIND_SPEED_SIZE[1]

let ctx = windProfileTemplate.getContext('2d')

windProfileConfigs.forEach((windProfileConfig, index) => {
  let y = index * WIND_SPEED_SIZE[1]
  let canvas = windProfileConfig.canvas
  delete windProfileConfig.canvas

  for (let angle = 0; angle <= 360; angle++) {
    let x = angle * WIND_SPEED_SIZE[0]
    ctx.save()
    ctx.translate(x + WIND_SPEED_CENTER[0], y + WIND_SPEED_CENTER[1])
    ctx.rotate(angle * (Math.PI / 180))
    ctx.translate(-(x + WIND_SPEED_CENTER[0]), -(y + WIND_SPEED_CENTER[1]))
    ctx.drawImage(
      canvas,
      0, 0,
      WIND_SPEED_SIZE[0], WIND_SPEED_SIZE[1],
      x, y,
      WIND_SPEED_SIZE[0], WIND_SPEED_SIZE[1]
    )
    ctx.restore()
  }
})

const MAX_SPEED = windProfileConfigs[WIND_PROFILE_CONFIG_LENGTH - 1].speed

export const getSpeedLevel = speed => {
  speed = Math.min(speed, MAX_SPEED)
  return windProfileConfigs.findIndex(windProfileConfig => speed <= windProfileConfig.speed)
}

console.timeEnd('wind profile template')



// WEBPACK FOOTER //
// ./src/components/Data/Charts/WindProfileChart/windProfileTemplate.js